import { useCallback, useEffect, useState } from 'react';

export default function useResizeObserver(resizeCallback: (el: HTMLElement) => void) {
  const [element, setElement] = useState<HTMLElement>();
  const memoizedResizeCallback = useCallback(resizeCallback, [resizeCallback]);

  useEffect(() => {
    if (element) {
      const resizeObserver = new ResizeObserver(() => requestAnimationFrame(() => memoizedResizeCallback(element)));

      resizeObserver.observe(element);

      return () => resizeObserver.disconnect();
    }
  }, [element, memoizedResizeCallback]);

  return useCallback((node: HTMLDivElement) => {
    if (node) {
      setElement(node);
    }
  }, []);
}
